import React, { Component } from 'react';

import { withRouteOptions } from 'components/hocs/withRouteOptions';
import ActionVacancyListTable from './ActionVacancyListTable';

const defaultActionVacancyListFilters = {
    planning: 1,
    gathering: 1,
    event: 1,
};

@withRouteOptions
export default class ActionVacancyListView extends Component {
    static routeOptions = {
        title: 'menu.actionVacancy'
    }

    state = {
        selected: null,
        filters: defaultActionVacancyListFilters
    };

    onSelect = selected => {
        this.setState({
            selected
        });
    };

    changeFilters = filters => {
        this.setState({ filters });
    };

    render() {
        return (
            <ActionVacancyListTable
                filters={this.state.filters}
                selected={this.state.selected}
                defaultFilters={defaultActionVacancyListFilters}
                onFiltersChange={this.changeFilters}
                onSelect={this.onSelect}
                {...this.props}
            />
        );
    }
}
